<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <el-button size="small" @click="goWarehouse">返回库存仓</el-button>
        <printViewBtn
          :changeList="printChangeList"
          :modules="OUTSOURCING_PRINT_MODULES.WAREHOUSE"
          :printFun="outsourcingWarehouse_view"
        />
      </div>
    </div>
    <hr />
    <div v-if="filterHint" class="filter-hint">{{ filterHint }}</div>
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    />
    <myHtml
      style="margin-top: 10px"
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :keyData="keyData"
      :checkKey="checkKey"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    />
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
  </div>
</template>

<script>
import { outsourcingWarehouse_flowList, outsourcingWarehouse_view } from "@/api/myController/outsourcing";
import { _debounce } from "@/utils/myUtils";
import {
  OUTSOURCING_PRINT_MODULES,
  buildPrintChangeList,
} from "@/utils/outsourcingPrint";
import {
  FLOW_DOC_TYPE_OPTIONS,
  FLOW_CHANGE_TYPE_OPTIONS,
  normalizeWarehouseFlowRow,
  buildWarehouseFlowListPayload,
} from "@/utils/outsourcingWarehouseFlow";
import { WAREHOUSE_MATERIAL_STATUS_OPTIONS } from "@/utils/outsourcingWarehouse";

export default {
  name: "cooperative_outsourcing_warehouse_flow",
  data() {
    return {
      topTitle: "委外库存流水",
      OUTSOURCING_PRINT_MODULES,
      outsourcingWarehouse_view,
      listLoading: false,
      columnType: "columnAll",
      tableBtnList: [],
      list: [],
      changeList: [],
      keyData: ["outsourcingWarehouseFlowId"],
      checkKey: "outsourcingWarehouseId",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        outsourcingWarehouseId: null,
      },
      searchData: {
        docType: "",
        productionOrMaterial: "",
        searchString: "",
      },
      filterHint: "",
      materialHint: "",
      operationTitleData: [],
      titleOperationTitleData: [
        // {
        //   name: "单据类型",
        //   value: "docType",
        //   type: "customSelect",
        //   selectOptionList: [
        //     { label: "全部", value: "" },
        //     ...FLOW_DOC_TYPE_OPTIONS,
        //   ],
        // },
        // {
        //   name: "物料类型",
        //   value: "productionOrMaterial",
        //   type: "customSelect",
        //   selectOptionList: [
        //     { label: "全部", value: "" },
        //     ...WAREHOUSE_MATERIAL_STATUS_OPTIONS,
        //   ],
        // },
        { name: "综合搜索", value: "searchString", type: "text" },
        { name: "搜索", type: "button" },
        { name: "重置", type: "button" },
      ],
      titleList: [
        {
          id: 1,
          name: "变动时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 160,
          sort: 10,
        },
        {
          id: 2,
          name: "单据类型",
          value: "docType",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: FLOW_DOC_TYPE_OPTIONS,
          canEdit: false,
          width: 140,
          sort: 20,
        },
        {
          id: 3,
          name: "变动类型",
          value: "changeType",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: FLOW_CHANGE_TYPE_OPTIONS,
          canEdit: false,
          width: 90,
          sort: 30,
        },
        {
          id: 4,
          name: "物料编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          color: "#409eff",
          width: 120,
          sort: 40,
        },
        {
          id: 5,
          name: "物料名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
          sort: 50,
        },
        {
          id: 6,
          name: "批次号",
          value: "batchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
          sort: 60,
        },
        {
          id: 7,
          name: "变动前",
          value: "wareStock",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 90,
          sort: 70,
        },
        {
          id: 8,
          name: "变动数量",
          value: "changeSum",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 100,
          sort: 80,
        },
        {
          id: 9,
          name: "结存",
          value: "remainderQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 90,
          sort: 90,
        },
        {
          id: 10,
          name: "物料类型",
          value: "productionOrMaterial",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: WAREHOUSE_MATERIAL_STATUS_OPTIONS,
          canEdit: false,
          width: 110,
          sort: 100,
        },
        {
          id: 11,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
          sort: 110,
        },
      ],
    };
  },
  computed: {
    printChangeList() {
      const rows = (this.changeList || []).filter(
        (item) => item && item.outsourcingWarehouseId
      );
      return buildPrintChangeList(rows, "outsourcingWarehouseId");
    },
  },
  created() {
    this.applyRouteQuery();
    this.getList = _debounce(this.getList, 200);
    this.getList();
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        this.applyRouteQuery();
        this.listQuery.pageNum = 1;
        this.getList();
      },
    },
  },
  methods: {
    applyRouteQuery() {
      const query = this.$route.query || {};
      const warehouseId =
        query.outsourcingWarehouseId || query.warehouseId || null;
      this.listQuery.outsourcingWarehouseId = warehouseId
        ? warehouseId
        : null;
      this.materialHint = [
        query.baseMaterialNumber,
        query.baseMaterialName,
        query.batchNumber ? `批次 ${query.batchNumber}` : "",
      ]
        .filter(Boolean)
        .join(" / ");
      if (this.listQuery.outsourcingWarehouseId) {
        this.filterHint = this.materialHint
          ? `当前筛选库存行：${this.materialHint}`
          : `当前筛选库存仓 ID：${this.listQuery.outsourcingWarehouseId}`;
      } else {
        this.filterHint = "";
      }
    },
    getList() {
      this.listLoading = true;
      outsourcingWarehouse_flowList(
        buildWarehouseFlowListPayload({
          outsourcingWarehouseId: this.listQuery.outsourcingWarehouseId,
          searchData: this.searchData,
          pageParam: {
            pageNum: this.listQuery.pageNum,
            pageSize: this.listQuery.pageSize,
          },
          orderParam: [{ asc: false, fieldName: "createTime" }],
        })
      )
        .then((res) => {
          const pageData = res.data.data || {};
          this.list = (pageData.dataList || []).map(normalizeWarehouseFlowRow);
          this.listQuery.total = pageData.totalCount || 0;
        })
        .catch(() => {
          this.list = [];
          this.listQuery.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
          this.$refs.myOperate?.dragSortShow();
        });
    },
    titleOperationBtnClick(item) {
      switch (item.name) {
        case "搜索":
          this.listQuery.pageNum = 1;
          this.getList();
          break;
        case "重置":
          this.searchData = {
            docType: "",
            productionOrMaterial: "",
            searchString: "",
          };
          this.listQuery.pageNum = 1;
          this.getList();
          break;
        default:
          break;
      }
    },
    operationBtnClick(item) {
      this.titleOperationBtnClick(item);
    },
    btnClick() {},
    goWarehouse() {
      this.$router.push({ name: "outsourcingProduct_warehouse" });
    },
    cellClickEvent() {},
    selectChangeEvent(val) {
      this.changeList = val.records || [];
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records || [];
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList;
    },
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    widthClick(titleList) {
      this.titleList = titleList;
    },
    resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title--font {
  text-align: left;
  padding: 10px 0;
}

.title--button {
  position: absolute;
  right: 0;
  margin-top: 0.7%;
}

.filter-hint {
  margin: 0 0 10px;
  padding: 8px 12px;
  color: #606266;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
}

::v-deep .operation {
  margin-bottom: 10px;
}

::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  box-sizing: border-box;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}

::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}

::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}

::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
</style>
